import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'treatment-leave-list',
  methods: {
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goTreatmentSalaryList: function () {
      this.$router.push({ path: '/treatment_salary_list' })
    },
    goTreatmentRuleList: function () {
      this.$router.push({ path: '/treatment_rule_list' })
    },
    goTreatmentDetail: function (pass) {
      this.$router.push({ path: '/treatment_detail/' + pass })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/treatment-leave-list.js